import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FlexLayoutModule} from '@angular/flex-layout';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import { CustomTooltipModule } from 'app/shared/directives/tooltip-directive.module';

import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTableModule} from '@angular/material/table';
import {ColorPickerModule} from 'ngx-color-picker';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';

import {CreateTagComponent} from './create-tag.component';
import {MatDividerModule} from '@angular/material/divider';

import {MatFormFieldModule} from '@angular/material/form-field';
import {MatSelectModule} from '@angular/material/select';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { StateFormComponent } from './state-form/state-form.component';
import { AutoFocusModule } from '../../auto-focus/auto-focus.module';
import { TagsService } from '../../services/tags.service';
import { TagValueComponent } from '../tag-value-dialog-model/tag-value-dialog-model.component';
import { CalculateTagComponent } from './calculate-tag/calculate-tag.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [CreateTagComponent, StateFormComponent, TagValueComponent, CalculateTagComponent],
    imports: [
        CommonModule,
        ColorPickerModule,
        MatFormFieldModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatIconModule,
        MatButtonModule,
        MatInputModule,
        MatCheckboxModule,
        MatTableModule,
        FlexLayoutModule,
        MatTabsModule,
        FormsModule,
        ReactiveFormsModule,
        MatDividerModule,
        AutoFocusModule,
        CustomTooltipModule,
        TranslateModule // translate module

    ],
    exports: [
        CreateTagComponent,
    ],
    providers: [TagsService]
})

export class CreateTagModule {}
